import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ButtonModule } from "primeng/button";

export type buttonStylesType =
  | "primary"
  | "secondary"
  | "success"
  | "danger"
  | "clean"
  | "outlined"
  | "outlined-secondary"
  | "clear-secondary";

@Component({
  selector: "app-button",
  imports: [ButtonModule, CommonModule],
  templateUrl: "./button.component.html",
  styleUrl: "./button.component.scss",
})
export class ButtonComponent {
  @Input() icon!: string;
  @Input() type: string = "button";
  @Input() disabled: boolean | undefined = false;
  @Input() loading: boolean = false;
  @Input() styleType: buttonStylesType = "primary"; // "primary" fica com fundo roxo e "secondary" com fundo amarelo
  @Input() style!: string;
  @Input() class!: string;
  @Input() rounded = false;

  @Output() btnClick = new EventEmitter();
}
